import React, { useEffect } from "react";
import { Button, Collapse, Grid, useTheme, Typography } from "@mui/material";
import { removeAllPins } from "../pins";
import { Step, useMap } from "../../../state/map";
import { SectionTitle } from "./SectionTitle";
import AddPin from '@mui/icons-material/AddLocationAlt';
import { StepProps } from "./types";

export const PinsStep = ({ expanded }: StepProps) => {
  const map = useMap();
  const { palette } = useTheme();
  useEffect(() => {
    window.pinsEnabled = true;
    return () => {
      window.pinsEnabled = false;
    }
  }, []);

  const onRemove = () => removeAllPins(map);

  return (
    <>
      <SectionTitle
        icon={AddPin}
        primary="Pins"
        secondary="Add pins to your map"
        step={Step.Pins}
      />
      <Collapse in={expanded} sx={{ pl: 2, py: 2, borderBottom: `${palette.primary.dark} solid 2px` }} unmountOnExit>
        <Grid item xs={12} textAlign="left" mb={2}>
          <Typography color="primary" variant="body1" fontSize="0.75em">
            <b>Pin Pricing:</b>
          </Typography>
          <Typography color="primary" variant="body2" fontSize="0.7em" mt={0.5}>
            • First pin: <b>Free</b>
          </Typography>
          <Typography color="primary" variant="body2" fontSize="0.7em">
            • Additional pins: Purchased in groups of 5
          </Typography>
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="center" m={2}>
          <Button onClick={onRemove} variant="outlined">Clear all pins</Button>
        </Grid>
      </Collapse>
    </>
  );
};
